import { render, staticRenderFns } from "./TenantList.vue?vue&type=template&id=53ae4d48&"
import script from "./TenantList.vue?vue&type=script&lang=ts&"
export * from "./TenantList.vue?vue&type=script&lang=ts&"
import style0 from "./TenantList.vue?vue&type=style&index=0&id=53ae4d48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports